import { Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { ILoadingOverlayParams } from 'ag-grid-community';

@Component({
  selector: 'cv-cxone-order-management-grid-loader',
  templateUrl: './cxone-order-management-grid-loader.component.html',
  styleUrl: './cxone-order-management-grid-loader.component.scss'
})
export class CxoneOrderManagementGridLoaderComponent implements ILoadingOverlayAngularComp {
  public params!: ILoadingOverlayParams & { loadingMessage: string }

  agInit(params: ILoadingOverlayParams & { loadingMessage: string }): void {
    this.params = params
  }
}
